export default __webpack_public_path__ + "static/dan-rather-medal-og-850039ad37cd0b8dd66a28a451e460e0.jpg";